import { Slide } from '@mui/material';
import { FC, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import {
  closeIssueModal,
  setCommentModal,
  setLastDrawerHeight,
} from '../../active-issues/store-actions/issue-store-actions';
import IssuesStore from '../../active-issues/stores/issues-store';
import IssueDrawer from '../components/IssueDrawer/IssueDrawer';
import IssueCard from '../components/IssueItem/IssueCard';
import useIssuesActions from '../hooks/use-issues-actions';

const IssueDrawerContainer: FC<
  React.PropsWithChildren<IssueDrawerContainerProps>
> = ({ className }) => {
  const {
    selectedIssue,
    loadingIssue,
    lastDrawerHeight,
    loadingJiraTicketsStatus,
    isActiveJiraConnection,
  } = useSnapshot(IssuesStore);
  const actions = useIssuesActions();

  const handleAddComment = useCallback(() => {
    setCommentModal(true);
  }, []);

  if (!selectedIssue) {
    return null;
  }

  return (
    <IssueDrawer
      className={className}
      title={selectedIssue.mainTitle}
      onClose={closeIssueModal}
      loading={loadingIssue}
      defaultHeight={lastDrawerHeight}
      isExclude={selectedIssue.excludedByAlert}
      onResizeStop={setLastDrawerHeight}
      actions={actions}
      issueId={selectedIssue.id}>
      <Slide style={{ height: '100%' }} direction='up' in>
        <div style={{ height: '100%' }}>
          <IssueCard
            onComment={handleAddComment}
            issueDetails={selectedIssue}
            loadingJiraTicketsStatus={loadingJiraTicketsStatus}
            isActiveJiraConnection={isActiveJiraConnection}
          />
        </div>
      </Slide>
    </IssueDrawer>
  );
};

interface IssueDrawerContainerProps {
  className: string;
}

export default IssueDrawerContainer;
